
import "../ElectricFuel.scss";

const VendorRatesSubFormTwo = ({ office }: { office: any }) => {
  const summaryFields = [
    { label: "Hub ID", value: office?.hub_id, icon: "fa fa-barcode" },
    { label: "Company", value: office?.vendor_company, icon: "fa fa-building" },
    { label: "Effective Date", value: office?.effective_date, icon: "fa fa-calendar" },
  ];

  const RatesDisplay = ({ rate_data }: { rate_data: any }) => {
    return (
      <>
        {rate_data?.map((item: any, index: any) => (
          <tr key={index}>
            <td>{item?.sd_hsn_id?.label || "N/A"}</td>
            <td>{item?.vehicle_type || "N/A"}</td>
            <td>{item?.rate_type?.label || "N/A"}</td>
            <td>{item?.min_start || "N/A"}</td>
            <td>{item?.min_end || "N/A"}</td>
            <td>{item?.price || "N/A"}</td>
            <td>{item?.extra_price || "N/A"}</td>
            <td>{item?.min_units_vehicle || "N/A"}</td>
            <td>{item?.min_units_type || "N/A"}</td>
          </tr>
        ))}
      </>
    );
  };

  return (
    <div className="p-4">
      <div className="detail-view-avatar">
        <i className="fa fa-bolt"></i>
      </div>

      <div className="columns is-multiline mb-3">
        {summaryFields.map((field, index) => (
          <div className="column is-4" key={index}>
            <div className="detail-view-field">
              <p className="detail-view-label">
                <i className={`${field.icon} mr-1`}></i> {field.label}
              </p>
              <p className="detail-view-value">{field.value || "N/A"}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="detail-view-divider"></div>

      <div className="smart-elf-table">
        <table className="table is-striped is-bordered is-fullwidth smart-efl-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>VH Type</th>
              <th>Rate Type</th>
              <th>Range Start</th>
              <th>Range End</th>
              <th>Price (Rs)</th>
              <th>Extra Price (Rs)</th>
              <th>Min Count</th>
              <th>Min Unit</th>
            </tr>
          </thead>
          <tbody>
            {office?.rate_data?.length ? (
              <RatesDisplay rate_data={office.rate_data} />
            ) : (
              <tr>
                <td colSpan={9} className="has-text-centered">
                  No rate data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VendorRatesSubFormTwo;
